var InjectedStackedWebmapDisplay;
export function setStackedWebmapDisplay(display) {
    InjectedStackedWebmapDisplay = display;
}
export function getStackedWebmapDisplay() {
    return InjectedStackedWebmapDisplay;
}
